import { Box, Button, Caption, Card, Heading, TextBlock } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./ai-support-card.scss";

export const AISupportCard = () => {
    const { t } = useTranslation();

    return (
        <Card className={style.cardBorder}>
            <Box columnLayout>
                <Box columnLayout gap={"Xxs"}>
                    <Heading disableTopSpacing disableBottomSpacing variant={"SUBTITLE_1"}>
                        {t("AiAgent.supportCard.title")}
                    </Heading>
                    <TextBlock>{t("AiAgent.supportCard.description")}</TextBlock>
                </Box>
                <Box gap={"Md"} paddingBottom={"Sm"} paddingTop={"Sm"} flexWrap={"Wrap"}>
                    <Button
                        variant={"Primary"}
                        onClick={() =>
                            window.open(
                                "https://portal.servicedesk.blancco.com/servicedesk/customer/user/login?destination=portals",
                                "_blank"
                            )
                        }
                    >
                        {t("AiAgent.supportCard.action_one")}
                    </Button>
                    <Button
                        variant={"Secondary"}
                        onClick={() => (window.location.href = `mailto:${t("Common.supportEmail")}`)}
                    >
                        {t("AiAgent.supportCard.action_two")}
                    </Button>
                </Box>
                <Caption greyTextStyle>{t("Common.supportEmail")}</Caption>
            </Box>
        </Card>
    );
};
